// extracted by mini-css-extract-plugin
export var container1 = "promoGalerie-module--container1--1NFcM";
export var hiddenTitle = "promoGalerie-module--hiddenTitle--26jwY";
export var mag = "promoGalerie-module--mag--2awN2";
export var title = "promoGalerie-module--title--1l0L-";
export var more = "promoGalerie-module--more--2weHR";
export var gallery = "promoGalerie-module--gallery--eUAk1";